import { appRoutes } from '@/router/routes/app'
import { authRoutes } from '@/router/routes/auth'
import { publicRoutes } from '@/router/routes/public'

export const routes = [...appRoutes, ...authRoutes, ...publicRoutes]
